import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=07dba8a2&scoped=true&"
import script from "./Attach.vue?vue&type=script&lang=ts&"
export * from "./Attach.vue?vue&type=script&lang=ts&"
import style0 from "./Attach.vue?vue&type=style&index=0&id=07dba8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dba8a2",
  null
  
)

export default component.exports